import React, { useState } from 'react';
import {
  Dropdown,
  Tooltip,
  OverlayTrigger,
  DropdownButton,
} from 'react-bootstrap';
import { Edit } from 'react-feather';
import { useTranslation } from 'react-i18next';
import ModalEditCustomer from '../Modal/ModalEditCustomer';
import ModalDeleteCustomer from '../Modal/ModalDeleteCustomer';
import { useDispatch, useSelector } from 'react-redux';
import { getDataCustomerUsers } from '../../pages/CustomerUsers/CustomerUsersSlice';
import { Link } from 'react-router-dom';

const DropdownEditCustomer = ({ show, setShow, customerId }) => {
  const [isEditCustomer, setIsEditCustomer] = useState(false);
  const [isDeleteCustomer, setIsDeleteCustomer] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const dataUser = useSelector((state) => state.profile.profile);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('error-permission')}
    </Tooltip>
  );

  const token = localStorage.getItem('token');

  const toCustomerUsersPage = (customerId) => {
    dispatch(getDataCustomerUsers({ token, customerId }));
  };

  return (
    <>
      {dataUser.authority === 'TENANT_ADMIN' ? (
        <>
          <DropdownButton
            size="sm"
            key="end"
            id="dropdown-button-drop-end"
            drop="end"
            variant="success"
            title={<Edit />}
          >
            <Dropdown.Item onClick={() => toCustomerUsersPage(customerId)}>
              <Link to={`/customers/${customerId}/users`} className="link">
                <span>{t('access-management')}</span>
              </Link>
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setIsEditCustomer(true)}>
              {t('edit-customer')}
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setIsDeleteCustomer(true)}>
              {t('delete-customer')}
            </Dropdown.Item>
          </DropdownButton>
          <ModalEditCustomer
            show={isEditCustomer}
            setShow={setIsEditCustomer}
            customerId={customerId}
          />
          <ModalDeleteCustomer
            show={isDeleteCustomer}
            setShow={setIsDeleteCustomer}
            customerId={customerId}
          />
        </>
      ) : (
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip}
        >
          <i
            class="fa fa-ban"
            style={{ color: 'red', fontSize: '25px' }}
            aria-hidden="true"
          ></i>
        </OverlayTrigger>
      )}
    </>
  );
};

export default DropdownEditCustomer;
